import React, { useState } from 'react';
import Footer from './components/Footer';
import InfoPage from './components/InfoPage';
import LegalModal from './components/LegalModal';
import Navbar from './components/Navbar';
import TutoringPlatform from './components/TutoringPlatform';
import WaitlistModal from './components/WaitlistModal.jsx';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [legalModal, setLegalModal] = useState({ isOpen: false, content: null });
  const [waitlistOpen, setWaitlistOpen] = useState(false);

  const handleLegalClick = (type) => {
    setLegalModal({
      isOpen: true,
      content: {
        type,
        title: type === 'privacy' ? 'Privacy Policy' : 
               type === 'terms' ? 'Terms of Service' : 'Cookie Policy'
      }
    });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar onNavigate={setCurrentPage} currentPage={currentPage} />
      <main className="flex-1">
        {currentPage === 'home' ? <TutoringPlatform /> : <InfoPage />}
      </main>
      <Footer onLegalClick={handleLegalClick} setWaitlistOpen={setWaitlistOpen} />
      <LegalModal 
        isOpen={legalModal.isOpen}
        content={legalModal.content}
        onClose={() => setLegalModal({ isOpen: false, content: null })}
      />
      <WaitlistModal isOpen={waitlistOpen} onClose={() => setWaitlistOpen(false)} />
    </div>
  );
}

export default App;
